import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack, Typography } from '@mui/material';
import React from 'react';
import { confirmable } from 'react-confirm';

type Props = {
    show?: boolean;
    proceed?: (boolean) => void;
    confirmation?: string;
    danger?: boolean;
    acknowledgement?: boolean;
    content?: React.ReactNode;
    callback?: () => void;
    options?: {
        confirmText?: string;
        cancelText?: string;
    };
};

const ConfirmDialog = ({ show, acknowledgement, proceed, danger, confirmation, content, callback, options }: Props) => {
    const confirmText = options?.confirmText || 'Confirmer';
    const cancelText = options?.cancelText || 'Annuler';

    return (
        <Dialog
            onClose={() => proceed(false)}
            open={show}
            scroll="paper">
            <DialogTitle>
                <Typography variant="inherit" component="span">
                    {confirmation}
                </Typography>
            </DialogTitle>
            {content && <DialogContent>{content}</DialogContent>}
            <DialogActions>
                <Stack
                    flexDirection={{
                        xs: 'column-reverse',
                        sm: 'row',
                    }}
                    gap={1}
                    justifyContent={'flex-end'}
                    width="100%">
                    {!acknowledgement && (
                        <Button
                            variant="text"
                            color="inherit"
                            onClick={() => proceed(false)}>
                            {cancelText}
                        </Button>
                    )}
                    <Button
                        sx={{
                            width: {
                                xs: '100%',
                                sm: 150,
                            },
                            borderRadius: 20,
                        }}
                        variant="contained"
                        color={danger ? 'error' : 'primary'}
                        onClick={() => {
                            callback?.();
                            proceed(true);
                        }}>
                        {confirmText}
                    </Button>
                </Stack>
            </DialogActions>
        </Dialog>
    );
};

// confirmable HOC pass props `show`, `dismiss`, `cancel` and `proceed` to your component.
export default confirmable(ConfirmDialog);
